module.exports = __webpack_public_path__ + "static/img/zhongxiao_bg_03.93a74a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zhongxiao_bg_03.png
// module id = 1cYE
// module chunks = 0